module.exports = __webpack_public_path__ + "static/img/用户运营全链路解决方案.f099a1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/用户运营全链路解决方案.png
// module id = yYTI
// module chunks = 0